import React from "react";
import ReactDOM from "react-dom";

const ProjectButton = React.memo(({ project, onClick, isSelected }) => {
  const [tooltip, setTooltip] = React.useState(null);

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setTooltip({
      top: rect.top + rect.height / 2,
      left: rect.right + 8,
    });
  };

  const handleMouseLeave = () => setTooltip(null);

  return (
    <>
      <button
        className={`home-project-button ${isSelected ? "selected" : ""}`}
        onClick={onClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <span>{project.project_name || project.name}</span>
        <span className="project-id">ID: {project.id}</span>
      </button>

      {tooltip &&
        ReactDOM.createPortal(
          <div
            className="home-project-tooltip"
            style={{ top: tooltip.top, left: tooltip.left }}
          >
            {project.project_name || project.name}
          </div>,
          document.body
        )}
    </>
  );
});

ProjectButton.displayName = "ProjectButton";

export default ProjectButton;